import React, { Component } from 'react'
import propTypes from 'prop-types'
import Icon from 'components/icon'
import Resizable from 'components/resizable'
import { prefix } from 'helpers/component'

export const HeaderHeight = 30
export const MinColumnSize = 20

const getClassName = prefix('pivotTable-columnHeader-')

class ColumnHeader extends Component {
  doSize = (newPos, oldPos) => {
    const curSize = this.props.size
    const newSize = curSize - oldPos.width + newPos.width
    this.props.onSize(newSize)
  }

  render () {
    const { label, sorted = false, size, align, sortDir, onSort, canSort = true, canSize = true, isDragPreview, isDragPlaceholder } = this.props

    let style = { textAlign: align || 'left' }
    if (isDragPreview) style = { ...style, width: size }

    const classes = ['column']
    if (isDragPreview) classes.push('column-drag-preview')

    if (isDragPlaceholder) {
      classes.push('column-drag-placeholder')
      return <span className={getClassName(classes)} style={style} />
    }

    let nextDir = 'asc'
    let sortIcon = null

    if (sorted) {
      if (sortDir === 'asc') {
        nextDir = 'desc'
        sortIcon = <Icon name="up4" size={8} />
      } else {
        nextDir = 'asc'
        sortIcon = <Icon name="down4" size={8} />
      }
    }

    let onClick
    if (canSort) onClick = () => onSort(nextDir)

    const content = (
      <span className={getClassName(classes)} style={style} onClick={onClick} onMouseDown={this.mouseDown}>
        {label}
        {sortIcon}
      </span>
    )

    if (canSize) return <Resizable handles={{ right: true }} handleSize={20} onSize={this.doSize} height={HeaderHeight}>{content}</Resizable>
    return content
  }
}

ColumnHeader.propTypes = {
  label: propTypes.oneOfType([
    propTypes.string,
    propTypes.number,
    propTypes.object,
  ]).isRequired,
  size: propTypes.oneOfType([
    propTypes.number,
    propTypes.string,
  ]),
  align: propTypes.string,
  sorted: propTypes.bool,
  sortDir: propTypes.oneOf(['asc', 'desc']),
  canSort: propTypes.bool,
  canSize: propTypes.bool,
  onSort: propTypes.func,
  onSize: propTypes.func,
  isDragPreview: propTypes.bool,
  isDragPlaceholder: propTypes.bool,
}

export default ColumnHeader
